//#region import
import React, { createContext, useEffect, useState } from 'react';
import GalleryShow from '../HomePage/components/GalleryShow';
import Register from '../HomePage/components/Register';
import { Grid, Typography } from '@mui/material';
import FilterYear from './FilterYear';
import { FnAxios, FnDialog } from 'utilities/utilities';
//#endregions

const FilterYearContext = createContext(null);
const Dashboard = () => {
    const [nYear, setnYear] = useState<any>(null);
    const [arrGallery, setGalleryData] = useState([]);
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    
    const onLoadData = () => {
        DialogFn.BlockUI();
        AxiosFn.Get("Home/GetHomeData", {}, (res) => {
            DialogFn.UnBlockUI();
            setGalleryData(res.lstGallery ?? [])
        }).then(
            () => {
                DialogFn.UnBlockUI();
            }
        );
    }

    useEffect(() => {
        onLoadData();
    }, []);
    
    return (
        <FilterYearContext.Provider value={{ setnYearFilter: setnYear }}>
            <Grid container item spacing={2} xs={12} md={12}>
                <Grid item xs={12} md={1.8}>
                    <FilterYear />
                </Grid>
                <Grid item xs={12} md={10.2}>
                    <Typography>Filter Year : {nYear}</Typography>
                    <br />
                    <Typography>ประวัติความเป็นมา</Typography>
                    <Typography>
                        กองทุนจัดการซากดึกดำบรรพ์เป็นมาตรการทางการเงิน ที่จัดตั้งขึ้นใน
                        กรมทรัพยากรธรณี โดยอาศัยอำนาจตามความในพระราชบัญญัติคุ้มครอง
                        ซากดึกดำบรรพ์ พ.ศ. 2551 หมวด 5 กองทุนจัดการซากดีกดำบรรพ์
                        มาตรา 38 ถึงมาตรา 46 (ภาคผนวก ก) เพื่อเป็นทุนสำหรับใข้จ่ายในการ
                        สนับสนุนและส่งเสริม การศึกษาวิจัย การอนุรักษ์ การพัฒนาบริหารจัดการ
                        แหล่งชากดึกดำบรรพ์ ซากดึกดำบรรพ์ การรวบรวมและจัดเก็บหลักฐาน
                        ทางธรณีวิทยาและธรรมชาติวิทยา และเก็บรักษาชากดีกดำบรรพ์ มี
                        กรมทรัพยากรณรณี โดยกองคุ้มครองชากดึกดำบรรพ์เป็นหน่วยบริหาร
                        งานกองทุนจัดการซากดึกดำบรรพ์ ภายใต้การกำกับดูแลของ คณะกรรมการ
                        บริหารกองทุนจัดการซากดึกดำบรรพ์ คณะกรรมการติดตามและประเมินผล
                        การดำเนินงานของ กองทุนจัดการซากดึกดำบรรพ์และ คณะกรรมการ
                        คุ้มครองชากดึกดำบรรพ์
                    </Typography>
                    <br />
                    <Register IsPreview={false}/>
                    <GalleryShow Gallery={arrGallery} IsPreview={false}/>
                </Grid>
            </Grid>
        </FilterYearContext.Provider>
    )
}
export default Dashboard;
export { FilterYearContext };
